type LoanType = 'personal' | 'business'
type PersonalStep = 'yourDetails' | 'aboutYou' | 'income' | 'financialPosition' | 'applicationOptions'
type BusinessStep = 'aboutYourBusiness' | 'aboutYou' | 'financialPosition' | 'applicationOptions'
type Step = PersonalStep | BusinessStep

export const preparePayload = (data: any, loanType: LoanType, step: Step) => {
  const searchParams = new URLSearchParams(window.location.search)
  const formId = searchParams.get('formid') || searchParams.get('formID') ||searchParams.get('formId')
  
  // Deep clone the data
  const payload = JSON.parse(JSON.stringify(data))

  // If formId exists, return the full payload without nullifying steps
  if (formId) {
    // Nullify applicationOptions as it's the last step and should by default be null
    if (loanType === 'personal') {
      if (step === 'yourDetails') {
        if (payload.personal.aboutYou.purchaseItems.itemType === '') {
          payload.personal.aboutYou = null
          payload.personal.income = null
          payload.personal.financialPosition = null
        }
      }
      payload.personal.applicationOptions = null
    } else {
      payload.business.applicationOptions = null
    }
    return payload
  }

  // Nullify steps based on the current step
  if (step !== 'applicationOptions') {
    if (loanType === 'personal') {
      payload.personal.applicationOptions = null
    } else {
      payload.business.applicationOptions = null
    }

    if (loanType === 'personal' && step === 'yourDetails') {
      if (payload.personal.aboutYou.purchaseItems.itemType === '') {
        payload.personal.aboutYou = null

        // That also mean user never went to other pages, so can nullify them as well
        payload.personal.income = null
        payload.personal.financialPosition = null
      }
    }
  }

  return payload
}
